export const TABLE_VIEWS_SETTING_KEY = 'tableViews';
export const PAGE_SIZE_SETTING_KEY = 'pageSize';

export interface TableColumnConfig {
  key: string;
  hidden?: boolean;
}

export interface SavedTableView {
  id: string;
  name: string;
  columns: TableColumnConfig[];
}

export interface TableViewsSettingValue {
  views: SavedTableView[];
  activeViewId?: string | null;
}
